import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';
import { ExpandButtonComponent } from '../expand-button/expand-button.component';

@Component({
  selector: 'acs-expandable-radio-button',
  imports: [ExpandButtonComponent],
  templateUrl: './expandable-radio-button.component.html',
  styleUrl: `./expandable-radio-button.component.scss`,
  changeDetection: ChangeDetectionStrategy.Default
})
export class ExpandableRadioButtonComponent {
  @Input() canExpand = true;
  @Input() expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  @ContentChild(MatRadioButton, { static: false }) radioBtn!: MatRadioButton;

  get _isChecked() {
    return !!this.radioBtn?.checked;
  }
  get _isDisabled() {
    return !!this.radioBtn?.disabled;
  }

  toggle(ev?: Event) {
    ev?.stopPropagation();
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
